import React from 'react';

const IconButton = ({ label, url, icon, alt, className }) => {
  return (
    <a href={url} 
    target='_blank' 
    rel='noopener noreferrer' 
    className={`btnesa ${className}`}>
      <img src={icon} alt={alt || ''} width="48" height="48" />
      <p>{label}</p>
    </a>
  );
};

export default IconButton;